import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsGenericTwoFactorErrorAlertVisible, getIsInvalidCodeAlertVisible, getIsNewCodeSentAlertVisible, getIsSmsRateLimitAlertVisible, getIsUserDeactivatedAlertVisible, getIsBlockedLoginMethodAlertVisible, getIsRestrictedIpAddressAlertVisible, isHubspotAuthenticatorErrorVisible } from 'LoginUI/selectors/TwoFactorAuth';
import { hideInvalidCodeAlert as hideInvalidCodeAlertAction } from 'LoginUI/actions';
export const use2faAlerts = () => {
  const dispatch = useDispatch();

  // Generic Two Factor Error Alert
  const isGenericTwoFactorErrorAlertVisible = useSelector(getIsGenericTwoFactorErrorAlertVisible);

  // Invalid Code Alert
  const isInvalidCodeAlertVisibleSelectorResult = useSelector(getIsInvalidCodeAlertVisible);
  const isInvalidCodeAlertVisible = Boolean(isInvalidCodeAlertVisibleSelectorResult);
  const hideInvalidCodeAlert = useCallback(() => {
    dispatch(hideInvalidCodeAlertAction);
  }, [dispatch]);

  // New Code Sent Alert
  const isNewCodeSentAlertVisible = useSelector(getIsNewCodeSentAlertVisible);

  // Sms Rate Limit Alert
  const isSmsRateLimitAlertVisible = useSelector(getIsSmsRateLimitAlertVisible);

  // User Deactivated Alert
  const isUserDeactivatedAlertVisible = useSelector(getIsUserDeactivatedAlertVisible);

  // Blocked Login Method Alert
  const isBlockedLoginMethodAlertVisible = useSelector(getIsBlockedLoginMethodAlertVisible);

  // Restricted Ip Address Alert
  const isRestrictedIpAddressAlertVisible = useSelector(getIsRestrictedIpAddressAlertVisible);

  // Hubspot Authenticator Error Alert
  const isHubspotAuthenticatorErrorAlertVisible = useSelector(isHubspotAuthenticatorErrorVisible);
  const isAnyAlertVisible = useMemo(() => isGenericTwoFactorErrorAlertVisible || isInvalidCodeAlertVisible || isNewCodeSentAlertVisible || isSmsRateLimitAlertVisible || isUserDeactivatedAlertVisible || isBlockedLoginMethodAlertVisible || isRestrictedIpAddressAlertVisible || isHubspotAuthenticatorErrorAlertVisible, [isGenericTwoFactorErrorAlertVisible, isInvalidCodeAlertVisible, isNewCodeSentAlertVisible, isSmsRateLimitAlertVisible, isUserDeactivatedAlertVisible, isBlockedLoginMethodAlertVisible, isRestrictedIpAddressAlertVisible, isHubspotAuthenticatorErrorAlertVisible]);
  return {
    isInvalidCodeAlertVisible,
    hideInvalidCodeAlert,
    isAnyAlertVisible
  };
};